<div id='rcScreenContainer' #rcScreenContainer>
  <canvas id="rcCanvas" #rcCanvas></canvas>
  <video #rcVideo id="rcVideo" playsinline="true" autoplay="" muted="muted"></video>
  <canvas id="rcInputCanvas" #rcInputCanvas></canvas>
</div>
